import { CompanyTag } from 'lib/api/company-tags/company-tags'
import { Brand } from './brand'
import { ProjectTemplate } from './project-template'

export enum ProjectStatus {
  ToDo = 'to_do',
  InProgress = 'in_progress',
  Done = 'done',
  NoStatus = 'no_status',
}

export enum ProjectStatusLabel {
  ToDo = 'To Do',
  InProgress = 'In Progress',
  Done = 'Done',
}

export interface Project {
  id: number
  description: string
  name: string
  updatedAt: string
  brand?: Brand
  tags?: CompanyTag[]
  ticketsRequiringAttentionCount: number
  projectTemplate?: ProjectTemplate
  status: ProjectStatus
  counters: {
    doneTickets: number
    inProgressTickets: number
    totalTickets: number
  }
}
